import React, { useState, useEffect } from 'react';
// import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux';
import ReactEcharts from 'echarts-for-react';
import Sticky from 'react-stickynode';
import {
  loadPairs,
  loadPerformance,
  setIndex,
  setPair,
  setDate,
  setPeriod,
  setCategory,
  setSort,
  setUrlDate,
  setUrlPeriod,
  setUrlCategory,
  saveToGA,
  loadAttributionExcel,
  setLoader,
} from '../../actions';
import { isMobileOnly } from 'react-device-detect';
import i18n from '../../i18n';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import withRouter from './withRouter';

import './style.css';

const THEMATIC = 'Thematic';

const App = props => {
  const {
    location,
    loadPairs,
    setIndex,
    setUrlDate,
    setUrlCategory,
    setUrlPeriod,
    setPair,
    setDate,
    setPeriod,
    setCategory,
    setSort,
    dates,
    pairs,
    index,
    categories,
    currentURL,
    forBlog,
    pair,
    category,
    categoryData,
    period,
    periodData,
    sortColumn,
    sortDirection,
    loadAttributionExcel,
    loadPerformance,
    setLoader,
    saveToGA,
  } = props;
  const isThematic = pair.fundCategoryTier2 === THEMATIC;
  useEffect(() => {
    const init = async () => {
      await loadPairs();
      const hash = location.hash.substring(1);
      if (hash !== '') {
        const hash = location.hash.substring(1).split('&');
        hashActions(hash);
      }
    };
    init();
  }, []);

  const hashActions = hash => {
    if (
      hash.length > 1 &&
      (hash[0] === 'perfattr' || hash[0] === 'index-attribution')
    ) {
      if (hash[1].includes('index')) {
        const idx = hash[1].split('index=')[1];
        setIndex(idx);
      }

      if (hash[3] && hash[3].includes('urlDate')) {
        const urlDate = hash[3].split('urlDate=')[1];
        setUrlDate(urlDate);
      }

      if (hash[4] && hash[4].includes('urlCategory')) {
        const urlCategory = hash[4].split('urlCategory=')[1];
        if (urlCategory.length > 0) {
          setUrlCategory(decodeURI(urlCategory));
        }
      }

      if (hash[5] && hash[5].includes('urlPeriod')) {
        const urlPeriod = hash[5].split('urlPeriod=')[1];
        if (urlPeriod.length > 0) {
          setUrlPeriod(urlPeriod);
        }
      }
    }
  };

  const getCategoryOptions = (indexes, category) => {
    let filtered = indexes.filter(index => index.category === category);
    return filtered.map(item => (
      <option key={item.index} value={item.index}>
        {item.index} - {item.index_name}
      </option>
    ));
  };

  const renderIndexes = () => {
    if (pairs) {
      // get unique indexes from the pairs
      let indexes = Array.from(
        pairs.reduce((m, t) => m.set(t.index, t), new Map()).values()
      );
      // fill in the category based on cat1 and cat2
      indexes = indexes.map(item => {
        item.category = '';
        if (item.fundCategoryTier1) {
          item.category =
            item.fundCategoryTier1 +
            (item.fundCategoryTier2 ? ' - ' + item.fundCategoryTier2 : '');
        } else {
          item.category = 'Other';
        }
        return item;
      });
      // get unique categories and sort
      let categories = Array.from(
        indexes
          .reduce((m, t) => m.set(t.category, t.category), new Map())
          .values()
      ).sort();
      // return index selection options grouped by category
      return categories.map(category => (
        <optgroup key={category} label={category}>
          {getCategoryOptions(indexes, category)}
        </optgroup>
      ));
    } else {
      return null;
    }
  };

  const renderPairs = () => {
    if (pairs) {
      let benchmarks = pairs.filter(function (value) {
        return value.index === index;
      });
      return benchmarks.map((item, idx) => (
        <option key={item.uu_attribution_id} value={item.uu_attribution_id}>
          {item.benchmark} - {item.benchmark_name}
        </option>
      ));
    } else {
      return null;
    }
  };

  const reorderCategories = categories => {
    var newCats = [];
    if (categories.includes('Sector')) newCats.push('Sector');
    if (categories.includes('Country')) newCats.push('Country');
    if (categories.includes('Region')) newCats.push('Region');
    if (categories.includes('DY')) newCats.push('DY');
    if (categories.includes('EY')) newCats.push('EY');
    if (categories.includes('GeoRev')) newCats.push('GeoRev');
    if (categories.includes('ROE')) newCats.push('ROE');
    if (categories.includes('SY')) newCats.push('SY');
    if (categories.includes('Share Class')) newCats.push('Share Class');
    if (categories.includes('SOE')) newCats.push('SOE');
    if (categories.includes('Size')) newCats.push('Size');
    if (categories.includes('Vol_Qtl')) newCats.push('Vol_Qtl');
    if (categories.includes('BV_Qtl')) newCats.push('BV_Qtl');
    if (categories.includes('Comp. Risk Score'))
      newCats.push('Comp. Risk Score');
    if (categories.includes('Industry')) newCats.push('Industry');
    if (categories.includes('SubIndustry')) newCats.push('SubIndustry');
    if (categories.includes('Time Since IPO')) newCats.push('Time Since IPO');
    if (categories.includes('WTSize')) newCats.push('WTSize');
    if (categories.includes('WTAIcategory')) newCats.push('WTAIcategory');
    if (categories.includes('VOLTcategory')) newCats.push('VOLTcategory');
    if (categories.includes('WCBRFocusGrowth')) newCats.push('WCBRFocusGrowth');
    if (categories.includes('WCBRFocus')) newCats.push('WCBRFocus');
    if (categories.includes('WCBRGrowth')) newCats.push('WCBRGrowth');
    if (categories.includes('WTREcategory')) newCats.push('WTREcategory');
    if (categories.includes('WRCYcategory')) newCats.push('WRCYcategory');
    if (categories.includes('WRCYsector')) newCats.push('WRCYsector');
    if (categories.includes('WBLKcategory')) newCats.push('WBLKcategory');
    if (categories.includes('WCARcategory')) newCats.push('WCARcategory');
    if (categories.includes('WRNWcategory')) newCats.push('WRNWcategory');
    // if(categories.includes('BB')) newCats.push('BB');
    return newCats;
  };

  const renderCategories = () => {
    if (categories) {
      function attrCatName(value) {
        switch (value) {
          case 'SY':
            return i18n.t('Shareholder Yield Attribution');
          //case 'BB':
          //  return 'Net Buyback Yield Attribution';
          case 'Size':
            return i18n.t('Size Attribution');
          case 'ROE':
            return i18n.t('Return on Equity Attribution');
          case 'EY':
            return i18n.t('Earnings Yield Attribution');
          case 'DY':
            return i18n.t('Dividend Yield Attribution');
          case 'Sector':
            return i18n.t('Sector Attribution');
          case 'Country':
            return i18n.t('Country Attribution');
          case 'Region':
            return i18n.t('Region Attribution');
          case 'Vol_Qtl':
            return i18n.t('Volatility Attribution');
          case 'BV_Qtl':
            return i18n.t('Book Value Attribution');
          case 'SOE':
            return i18n.t('State-Ownership Attribution');
          case 'GeoRev':
            return i18n.t('Geographic Revenue Attribution');
          case 'Share Class':
            return i18n.t('Share Class Attribution');
          case 'Comp. Risk Score':
            return i18n.t('CRS Attribution');
          case 'Industry':
            return i18n.t('GICS Industry attribution');
          case 'SubIndustry':
            return i18n.t('GICS Sub-Industry attribution');
          case 'Time Since IPO':
            return i18n.t('Attribution by time since IPO / first listing date');
          case 'WTSize':
            return i18n.t('Market cap attribution');
          case 'WTAIcategory':
            return i18n.t('WisdomTree AI proprietary categories');
          case 'VOLTcategory':
            return i18n.t(
              'WisdomTree Battery Solutions proprietary categories'
            );
          case 'WCBRFocusGrowth':
            return i18n.t(
              'WisdomTree Cybersecurity Focus & Growth proprietary categories'
            );
          case 'WCBRFocus':
            return i18n.t(
              'WisdomTree Cybersecurity Focus Score proprietary categories'
            );
          case 'WCBRGrowth':
            return i18n.t(
              'WisdomTree Cybersecurity Growth Score proprietary categories'
            );
          case 'WTREcategory':
            return i18n.t(
              'WisdomTree New Economy Real Estate proprietary categories'
            );
          case 'WRCYcategory':
            return i18n.t(
              'WisdomTree Recycling Decarbonisation proprietary categories'
            );
          case 'WRCYsector':
            return i18n.t(
              'WisdomTree Recycling Decarbonisation proprietary categories'
            );
          case 'WBLKcategory':
            return i18n.t(
              'WisdomTree Recycling Decarbonisation proprietary sectors'
            );

          case 'WCARcategory':
            return i18n.t(
              'WisdomTree Automotive Innovators proprietary categories'
            );
          case 'WRNWcategory':
            return i18n.t('WisdomTree Renewable Energy proprietary categories');
          default:
            return value;
        }
      }
      let sortedCats = reorderCategories(categories);
      return sortedCats.map((cat, index) => (
        <option key={cat} value={cat}>
          {attrCatName(cat)}
        </option>
      ));
    } else {
      return null;
    }
  };

  const renderGlossary = () => {
    if (categories) {
      function attrCatGlossary(value) {
        switch (value) {
          case 'SY':
            return i18n.t('SY-gloss');
          case 'BB':
            return i18n.t('BB-gloss');
          case 'ROE':
            return i18n.t('ROE-gloss');
          case 'EY':
            return i18n.t('EY-gloss');
          case 'DY':
            return i18n.t('DY-gloss');
          default:
            return null;
        }
      }
      let result = attrCatGlossary(category);
      return <div className="perffooter">{result}</div>;
    } else {
      return null;
    }
  };

  const renderPeriods = () => {
    if (categoryData.periods) {
      let names = {
        MTD: 1,
        QTD: 2,
        YTD: 3,
        '1y': 4,
        '3y': 5,
        '5y': 6,
        '10y': 7,
        SI: 8,
      };
      function checkForSI(value) {
        switch (value) {
          case 'SI':
            return i18n.t('Since Inception') + '*';
          case '1y':
            return i18n.t('1Y');
          case '3y':
            return i18n.t('3Y');
          case '5y':
            return i18n.t('5Y');
          case '10y':
            return i18n.t('10Y');
          default:
            return i18n.t(value);
        }
      }
      return categoryData.periods
        .sort((a, b) => names[a.name] - names[b.name])
        .map((period, index) => (
          <button
            id={'btn' + period.name}
            key={period.name}
            className={buttonPeriodClass(period.name)}
            onClick={() => setPeriod(period.name)}
          >
            {checkForSI(period.name)}
          </button>
        ));
    } else {
      return null;
    }
  };

  const getDateCode = theDate => {
    return new Date(theDate)
      .toISOString()
      .replace('-', '')
      .split('T')[0]
      .replace('-', '');
  };

  const renderDates = () => {
    if (dates) {
      return dates.map((date, index) => (
        <option key={index} value={getDateCode(date.asOfDate)}>
          {new Date(date.asOfDate).toLocaleDateString().split(',')[0]}
        </option>
      ));
    } else {
      return null;
    }
  };

  const getSaveToGA = (event, val) => {
    event.preventDefault();
    if (val === 'link') {
      saveToGA('copy link');
    } else {
      saveToGA('excel download');
    }
  };

  const getExcelDownload = event => {
    event.preventDefault();
    loadAttributionExcel();
  };

  const getAsOfDate = () => {
    if (periodData.length > 0) {
      return getDateCode(periodData[0].date);
    } else {
      return '';
    }
  };

  const convPerc = value => {
    return Number.parseFloat(value * 100).toFixed(2);
  };

  const renderTable = () => {
    if (periodData) {
      return periodData.map((item, index) => (
        <tr
          key={index}
          style={{ fontWeight: item.Category === 'Total' ? 'bold' : '500' }}
        >
          <td rowname="Category">{item.Category}</td>
          <td rowname="Allocation">{convPerc(item.Allocation)}%</td>
          <td rowname="Stock Selection">{convPerc(item.Selection)}%</td>
          <td rowname="Interaction">{convPerc(item.Interaction)}%</td>
          <td rowname="Total Attribution">{convPerc(item.Total)}%</td>
          <td rowname="Index Weight">
            {item.Category !== 'Total' ? convPerc(item.IndexWgt) + '%' : '-'}
          </td>
          <td rowname="Benchmark Weight">
            {item.Category !== 'Total'
              ? convPerc(item.BenchmarkWgt) + '%'
              : '-'}
          </td>
          <td rowname="+ / - Weight">
            {item.Category !== 'Total' ? convPerc(item.ActiveWgt) + '%' : '-'}
          </td>
          <td rowname="WT Index Returns">{convPerc(item.IndexGroupRet)}%</td>
          <td rowname="Benchmark Returns">
            {convPerc(item.BenchmarkGroupRet)}%
          </td>
        </tr>
      ));
    } else {
      return null;
    }
  };

  const buttonPeriodClass = type => {
    return type === period ? 'button-selected' : '';
  };

  const setTblHeadClass = type => {
    if (type === sortColumn && sortDirection === 'DESC') {
      return 'des';
    } else if (type === sortColumn && sortDirection === 'ASC') {
      return 'asc';
    } else {
      return '';
    }
  };

  const renderGraphs = () => {
    if (forBlog) {
      return null;
    }

    return (
      <div>
        <div className="row">
          <div className="perf-details col chart-container">
            <ReactEcharts
              option={getAttributionOption()}
              theme="default"
              style={{ height: 500 }}
              notMerge="false"
            />
          </div>
        </div>
        <div className="row">
          <div
            className="perf-details chart-container col-md-6"
            style={{ borderRight: '5px solid white' }}
          >
            <ReactEcharts
              option={getAverageWeightsOption()}
              theme="default"
              style={{ height: 400 }}
              notMerge="false"
            />
          </div>
          <div
            className="perf-details col-md-6 chart-container"
            style={{ borderLeft: '5px solid white' }}
          >
            <ReactEcharts
              option={getOverUnderOption()}
              theme="default"
              style={{ height: 400 }}
              notMerge="false"
            />
          </div>
        </div>
      </div>
    );
  };

  const renderThematicGraphs = () => {
    if (forBlog) {
      return null;
    }

    return (
      <div>
        <div className="row">
          <div className="perf-details col chart-container">
            <ReactEcharts
              option={getThematicAttributionOption()}
              theme="default"
              style={{ height: 500 }}
              notMerge="false"
            />
          </div>
        </div>
        <div className="row">
          <div
            className={`perf-details chart-container`}
            style={{ borderRight: '5px solid white' }}
          >
            <ReactEcharts
              option={getThematicAverageWeightsOption()}
              theme="default"
              style={{ height: 400 }}
              notMerge="false"
            />
          </div>
        </div>
      </div>
    );
  };

  const renderThematicTable = () => {
    if (periodData) {
      return periodData.map((item, index) => (
        <tr
          key={index}
          style={{ fontWeight: item.Category === 'Total' ? 'bold' : '500' }}
        >
          <td rowname="Category">{item.Category}</td>
          <td rowname="Contribution to Return (CTR)">
            {convPerc(item.Total)}%
          </td>
          <td rowname="Average Weight">
            {item.Category !== 'Total' ? convPerc(item.IndexWgt) + '%' : '-'}
          </td>
          <td rowname="Group Return">{convPerc(item.IndexGroupRet)}%</td>
        </tr>
      ));
    } else {
      return null;
    }
  };
  const renderThematicDataTable = () => {
    return (
      <div className="row">
        <div
          className="perf-details col table-responsive"
          style={{ marginTop: '0px' }}
        >
          <table className="table">
            <thead>
              <tr className="second">
                <th
                  rowname="Category"
                  className={'textLeft ' + setTblHeadClass('Category')}
                  onClick={e => setSort('Category')}
                >
                  {i18n.t('Category')}
                </th>
                <th
                  rowname="Contribution to Return (CTR)"
                  className={setTblHeadClass('Total')}
                  onClick={() => setSort('Total')}
                >
                  {i18n.t('Contrbution to Return (CTR)')}
                </th>
                <th
                  rowname="Average Weight"
                  className={setTblHeadClass('IndexWgt')}
                  onClick={() => setSort('IndexWgt')}
                  style={{ borderLeft: '1px solid white' }}
                >
                  {i18n.t('Average Weight')}
                </th>

                <th
                  rowname="Group Return"
                  className={setTblHeadClass('IndexGroupRet')}
                  onClick={() => setSort('IndexGroupRet')}
                  style={{ borderLeft: '1px solid white' }}
                >
                  {i18n.t('Group Return')}
                </th>
              </tr>
            </thead>
            <tbody>{renderThematicTable()}</tbody>
          </table>
        </div>
      </div>
    );
  };
  const renderDataTable = () => {
    return (
      <div className="row">
        <div
          className="perf-details col table-responsive"
          style={{ marginTop: '0px' }}
        >
          <table className="table">
            <thead>
              <tr className="first" style={{ fontStyle: 'italic' }}>
                <th>&nbsp;</th>
                <th colSpan="4">{i18n.t('Attribution Component')}</th>
                <th colSpan="3">{i18n.t('Average Category Weight')}</th>
                <th colSpan="2">{i18n.t('Category Performance')}</th>
              </tr>
              <tr className="second">
                <th
                  rowname="Category"
                  className={'textLeft ' + setTblHeadClass('Category')}
                  onClick={e => setSort('Category')}
                >
                  {i18n.t('Category')}
                </th>
                <th
                  rowname="Allocation"
                  className={setTblHeadClass('Allocation')}
                  onClick={() => setSort('Allocation')}
                  style={{ borderLeft: '1px solid white' }}
                >
                  {i18n.t('Allocation')}
                </th>
                <th
                  rowname="Selection"
                  className={setTblHeadClass('Selection')}
                  onClick={() => setSort('Selection')}
                >
                  Stock
                  <br />
                  {i18n.t('Selection')}
                </th>
                <th
                  rowname="Interaction"
                  className={setTblHeadClass('Interaction')}
                  onClick={() => setSort('Interaction')}
                >
                  {i18n.t('Interaction')}
                </th>
                <th
                  rowname="Total"
                  className={setTblHeadClass('Total')}
                  onClick={() => setSort('Total')}
                >
                  Total
                  <br />
                  {i18n.t('Attribution')}
                </th>
                <th
                  rowname="IndexWgt"
                  className={setTblHeadClass('IndexWgt')}
                  onClick={() => setSort('IndexWgt')}
                  style={{ borderLeft: '1px solid white' }}
                >
                  {i18n.t('Index')}
                  <br />
                  {i18n.t('Weight')}
                </th>
                <th
                  rowname="BenchmarkWgt"
                  className={setTblHeadClass('BenchmarkWgt')}
                  onClick={() => setSort('BenchmarkWgt')}
                >
                  {i18n.t('Benchmark')}
                  <br />
                  {i18n.t('Weight')}
                </th>
                <th
                  rowname="ActiveWgt"
                  className={setTblHeadClass('ActiveWgt')}
                  onClick={() => setSort('ActiveWgt')}
                >
                  +/- {i18n.t('Wgt')}
                </th>
                <th
                  rowname="IndexGroupRet"
                  className={setTblHeadClass('IndexGroupRet')}
                  onClick={() => setSort('IndexGroupRet')}
                  style={{ borderLeft: '1px solid white' }}
                >
                  WT {i18n.t('Index')}
                  <br />
                  {i18n.t('Return')}
                </th>
                <th
                  rowname="BenchmarkGroupRet"
                  style={{ textAlign: 'center' }}
                  className={setTblHeadClass('BenchmarkGroupRet')}
                  onClick={() => setSort('BenchmarkGroupRet')}
                >
                  {i18n.t('Benchmark')}
                  <br />
                  {i18n.t('Return')}
                </th>
              </tr>
            </thead>
            <tbody>{renderTable()}</tbody>
          </table>
        </div>
      </div>
    );
  };

  const renderAllFooters = () => {
    let dateFormat = { month: 'numeric', day: 'numeric', year: 'numeric' };
    if (forBlog) {
      return null;
    }
    return (
      <div>
        <div className="perffooter">
          {i18n.t('comp-source')}:{' '}
          {new Date(pair.inception_date).toLocaleString('en-US', dateFormat)}
          &nbsp;&nbsp;&nbsp;
          <a href={pair.index_url} target="_new">
            {i18n.t('comp-view')}
          </a>
        </div>
        <div className="perffooter">{i18n.t('comp-inception')}</div>
        {renderGlossary()}
        <div className="perffooter">{i18n.t('Composite Risk Score')}</div>
        <div className="perffooter">{i18n.t('comp-average')}</div>
        <div className="perffooter-b">{i18n.t('comp-past')}</div>
        <div className="perffooter-b">{i18n.t('comp-std')}</div>
        <div className="perffooter-b">{i18n.t('comp-prospectus')}</div>
      </div>
    );
  };

  const renderCopyDownload = () => {
    if (forBlog) {
      return null;
    }
    return (
      <div className="row">
        <div className="col-md-12" style={{ padding: '0px' }}>
          <div className="right">
            {/* <a id="excel-download" className="downloadExcelLink">{i18n.t('Fetching Excel')}</a> */}
            <a
              className={'downloadExcelLink'}
              onClick={event => getExcelDownload(event)}
            >
              {' '}
              DOWNLOAD EXCEL
            </a>
          </div>
          <div className="right" style={{ marginLeft: '10px' }}>
            <CopyToClipboard text={currentURL}>
              <a
                className={'downloadExcelLink'}
                onClick={event => getSaveToGA(event, 'link')}
              >
                {' '}
                COPY LINK
              </a>
            </CopyToClipboard>
          </div>
        </div>
      </div>
    );
  };

  const renderData = () => {
    return (
      <div>
        {pair.index && (
          <div>
            {renderCopyDownload()}
            {isThematic ? renderThematicDataTable() : renderDataTable()}
            {isThematic ? renderThematicGraphs() : renderGraphs()}
            {renderAllFooters()}
          </div>
        )}
      </div>
    );
  };

  const renderStickyHeader = () => {
    return (
      <Sticky innerZ={5} enabled={false} top={0}>
        <div style={{ backgroundColor: 'white', paddingBottom: '10px' }}>
          <div className="row">
            <div className="col-md-6 perf-btn-group">
              <select
                onChange={event => {
                  setIndex(event.target.value);
                  setUrlCategory('Sector');
                  setUrlPeriod('SI');
                }}
                value={index}
              >
                {Object.keys(pair).length === 0 && (
                  <option value="">
                    {i18n.t('Select a WisdomTree Index')}
                  </option>
                )}
                {renderIndexes()}
              </select>
            </div>
            {index && pair.benchmark && pair.benchmark !== 'None' && (
              <div className="col-md-1 perf-btn-group versus">VS.</div>
            )}
            {index && pair.benchmark && pair.benchmark !== 'None' && (
              <div className="col-md-5 perf-btn-group">
                <select
                  style={{ fontSize: '13px' }}
                  onChange={event => setPair(event.target.value)}
                  value={pair.uu_attribution_id}
                >
                  {Object.keys(pair).length === 0 && (
                    <option value="">{i18n.t('Select a Benchmark')}</option>
                  )}
                  {renderPairs()}
                </select>
              </div>
            )}
          </div>

          {pair.index && (
            <div className="row">
              <div className="col-md-3 perf-btn-group">
                <select
                  onChange={event => setCategory(event.target.value)}
                  value={category}
                >
                  {renderCategories()}
                </select>
              </div>
              <div className="col-md-1 perf-btn-group">
                <div className="asofdate">{i18n.t('As of')}:</div>
              </div>
              <div className="col-md-2 perf-btn-group">
                <select
                  onChange={event => setDate(event.target.value)}
                  value={getAsOfDate()}
                >
                  {renderDates()}
                </select>
              </div>
              <div className="col-md-6 perf-btn-group">
                <div className="right">{renderPeriods()}</div>
              </div>
            </div>
          )}
        </div>
      </Sticky>
    );
  };

  const getHBarOption = () => {
    return {
      title: {
        text: '',
        left: 12,
        textStyle: {
          fontStyle: 'normal',
          fontWeight: 900,
          fontSize: 15,
          color: '#8c959b',
        },
      },
      legend: {
        data: [],
        itemGap: 20,
        right: 18,
        top: 30,
      },
      tooltip: {
        trigger: 'axis',
        formatter: function (params, ticket) {
          var res = params[0].name;
          for (var i = 0, l = params.length; i < l; i++) {
            res +=
              '<br/>' +
              params[i].marker +
              ' ' +
              i18n.t(params[i].seriesName) +
              ' : ' +
              params[i].value +
              '%';
          }
          return res;
        },
        backgroundColor: '#FFF',
        borderWidth: 1,
        borderColor: '#05A9B1',
        borderRadius: 0,
        textStyle: {
          color: '#5B6770',
          align: 'left',
        },
      },
      grid: {
        left: '3%',
        right: '4%',
        bottom: '3%',
        containLabel: true,
      },
      xAxis: [
        {
          type: 'value',
          axisLabel: {
            formatter: '{value} %',
          },
        },
      ],
      yAxis: [
        {
          type: 'category',
          axisLabel: {
            fontSize: 12,
            fontWeight: 100,
            color: '#596770',
          },
          axisPointer: {
            type: 'shadow',
          },
          data: [],
        },
      ],
      series: [],
    };
  };

  const filterOutTotal = data => {
    let categoryData = data.filter(function (value) {
      return value.Category !== i18n.t('Total');
    });
    return categoryData;
  };

  const getAverageWeightsOption = () => {
    let indexLbl = i18n.t('Index') + ' (' + pair.index + ')';
    let benchLbl = i18n.t('Benchmark') + ' (' + pair.benchmark + ')';
    let data = periodData;
    let option = getHBarOption();
    option.title.text = i18n.t('Average Weights');
    option.legend.data = [indexLbl, benchLbl];
    let filteredData = filterOutTotal(data);
    option.yAxis[0].data = filteredData
      .map(row => i18n.t(row.Category))
      .slice()
      .reverse();
    option.series = [
      {
        type: 'bar',
        name: indexLbl,
        itemStyle: { color: 'darkblue' },
        data: filteredData
          .map(item => convPerc(item.IndexWgt))
          .slice()
          .reverse(),
      },
      {
        type: 'bar',
        name: benchLbl,
        itemStyle: { color: '#0fcbd4' },
        data: filteredData
          .map(item => convPerc(item.BenchmarkWgt))
          .slice()
          .reverse(),
      },
    ];
    return option;
  };

  const getThematicAverageWeightsOption = () => {
    let indexLbl = i18n.t('Index') + ' (' + pair.index + ')';
    let benchLbl = !isThematic
      ? i18n.t('Benchmark') + ' (' + pair.benchmark + ')'
      : '';
    let data = periodData;
    let option = getHBarOption();
    option.title.text = i18n.t('Average Weights');
    option.legend.data = [indexLbl, benchLbl];
    let filteredData = filterOutTotal(data);
    option.yAxis[0].data = filteredData
      .map(row => i18n.t(row.Category))
      .slice()
      .reverse();
    option.series = [
      {
        type: 'bar',
        name: indexLbl,
        itemStyle: { color: 'darkblue' },
        data: filteredData
          .map(item => convPerc(item.IndexWgt))
          .slice()
          .reverse(),
      },
    ];
    return option;
  };

  const getOverUnderOption = () => {
    let data = periodData;
    let option = getHBarOption();
    option.title.text = i18n.t('Over/Under Weight');
    option.legend.data = [];
    let filteredData = filterOutTotal(data);
    option.yAxis[0].data = filteredData
      .map(row => i18n.t(row.Category))
      .slice()
      .reverse();
    option.series = [
      {
        type: 'bar',
        name: 'Index',
        itemStyle: { color: 'darkgreen' },
        data: filteredData
          .map(item => convPerc(item.ActiveWgt))
          .slice()
          .reverse(),
      },
    ];
    return option;
  };

  const getVBarOption = () => {
    return {
      title: {
        text: '',
        left: 12,
        textStyle: {
          fontStyle: 'normal',
          fontWeight: 900,
          fontSize: 15,
          color: '#8c959b',
        },
      },
      legend: {
        itemGap: 20,
        top: 30,
        data: [],
      },
      tooltip: {
        trigger: 'axis',
        formatter: function (params, ticket) {
          var res = params[0].name;
          for (var i = 0, l = params.length; i < l; i++) {
            res +=
              '<br/>' +
              params[i].marker +
              ' ' +
              i18n.t(params[i].seriesName) +
              ' : ' +
              params[i].value +
              '%';
          }
          return res;
        },
        backgroundColor: '#FFF',
        borderWidth: 1,
        borderColor: '#05A9B1',
        borderRadius: 0,
        textStyle: {
          color: '#5B6770',
          align: 'left',
        },
      },
      grid: {
        left: '3%',
        right: '4%',
        bottom: '3%',
        containLabel: true,
      },
      xAxis: [
        {
          type: 'category',
          axisLabel: {
            fontSize: 12,
            fontWeight: 100,
            color: '#596770',
            rotate: 45,
            interval: 0,
            align: 'right',
          },
          axisPointer: {
            type: 'shadow',
          },
          data: [],
        },
      ],
      yAxis: [
        {
          type: 'value',
          axisLabel: {
            formatter: '{value} %',
          },
        },
      ],
      series: [],
    };
  };

  const getAttributionOption = () => {
    let data = periodData;
    let option = getVBarOption();
    option.title.text = i18n.t('Performance Attribution');
    option.legend.data = [
      i18n.t('Allocation'),
      i18n.t('Selection'),
      i18n.t('Interaction'),
      i18n.t('Total Attribution'),
    ];
    if (isMobileOnly) {
      option.grid.top = 100;
    }
    option.xAxis[0].data = data.map(row => i18n.t(row.Category));
    option.series = [
      {
        type: 'bar',
        stack: 'true',
        name: 'Allocation',
        itemStyle: { color: '#0fcbd4' },
        data: data.map(item => convPerc(item.Allocation)),
      },
      {
        type: 'bar',
        stack: 'true',
        name: 'Selection',
        itemStyle: { color: 'darkblue' },
        data: data.map(item => convPerc(item.Selection)),
      },
      {
        type: 'bar',
        stack: 'true',
        name: 'Interaction',
        itemStyle: { color: '#8c959b' },
        data: data.map(item => convPerc(item.Interaction)),
      },
      {
        type: 'scatter',
        symbol: 'diamond',
        symbolSize: 20,
        name: 'Total Attribution',
        itemStyle: { color: 'orange', opacity: 1 },
        data: data.map(item => convPerc(item.Total)),
      },
    ];
    return option;
  };

  const getThematicAttributionOption = () => {
    let data = periodData;
    let option = getVBarOption();
    option.title.text = i18n.t('Performance Attribution');
    option.legend.data = [i18n.t('Contribution to Return (CTR)')];
    if (isMobileOnly) {
      option.grid.top = 100;
    }
    option.xAxis[0].data = data.map(row => i18n.t(row.Category));
    option.series = [
      {
        type: 'bar',
        stack: 'true',
        name: i18n.t('Contribution to Return (CTR)'),
        itemStyle: { color: '#050139' },
        data: data.map(item => convPerc(item.Total)),
      },
    ];
    return option;
  };
  console.log(props);
  return (
    <div className="perf-attr">
      <div className="perf-btn-toolbar" role="toolbar">
        {renderStickyHeader()}
        {categoryData ? renderData() : <div> Something went wrong</div>}
      </div>
    </div>
  );
};

function mapStateToProps(state) {
  return {
    pairs: state.performance.pairs,
    index: state.performance.index,
    pair: state.performance.pair,
    dates: state.performance.dates,
    categories: state.performance.categories,
    category: state.performance.category,
    categoryData: state.performance.categoryData,
    period: state.performance.period,
    periodData: state.performance.periodData,
    sortColumn: state.performance.sortColumn,
    sortDirection: state.performance.sortDirection,
    currentURL: state.performance.currentURL,
  };
}
const mapDispatchToProps = {
  loadPairs,
  loadPerformance,
  setIndex,
  setPair,
  setDate,
  setPeriod,
  setCategory,
  setSort,
  setUrlDate,
  setUrlPeriod,
  setUrlCategory,
  saveToGA,
  loadAttributionExcel,
  setLoader,
};
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App));
